const ATTRIBUTE_MENU = 'data-klt-c-menu';
const ATTRIBUTE_MENU_TOGGLE = 'data-klt-c-menu-toggle';
const ATTRIBUTE_MENU_LIST = 'data-klt-c-menu-list';
const ATTRIBUTE_MENU_LIST_TOGGLE = 'data-klt-c-menu-list-toggle-for';
const CLASS_MENU_OPEN = 'klt-c-menu--active';
const CLASS_MENU_INACTIVE = 'klt-c-menu--inactive';
const CLASS_MENU_EXPANDED = 'klt-c-menu__list--expanded';

const menus: MenuProps[] = [];

export default init;

export function init() {
    try {
        const menuElements = document.querySelectorAll(`[${ATTRIBUTE_MENU}]`);

        if (menuElements.length > 0) {
            for (let i = 0; i < menuElements.length; i++) {
                const container = menuElements[i] as Element;
                const toggle = container.querySelector(`[${ATTRIBUTE_MENU_TOGGLE}]`);
                const list = container.querySelector(`[${ATTRIBUTE_MENU_LIST}]`);
                const subpageToggles = container.querySelectorAll(`[${ATTRIBUTE_MENU_LIST_TOGGLE}]`);

                document.documentElement.classList.add('klt-u-menu-js-loaded');
                sessionStorage.menuLoaded = true;

                const menu: MenuProps = {
                    container,
                    toggle,
                    list,
                    subpageToggles,
                    subpages: {
                        activeIndex: 0
                    },
                    isOpen: false,
                    isSubmenuExpanded: false
                };

                /* Cache elements for better state management */
                menus.push(menu);

                attachMenuToggleEventHandler(toggle, i);

                for (let iToggle = 0; iToggle < subpageToggles.length; iToggle++) {
                    const subpageToggle = subpageToggles[iToggle];
                    attachSubpageToggleEventHandler(subpageToggle, i);
                }
            }
        }
    } catch (e) {
        console.error(`Couldn't initalize menu module.`, e);
    }
}

function attachMenuToggleEventHandler(element: Element, menuIndex: number) {
    element.addEventListener('click', () => {
        const menu = menus[menuIndex];

        if (!menu.isOpen) {
            // Close and deactivate other instances of menus if a menu gets opened
            menus.forEach(otherMenu => {
                if (otherMenu !== menu) {
                    deactivateMenu(otherMenu);
                }
            });

            openMenu(menu);
        } else {
            closeMenu(menu);

            menus.forEach(otherMenu => {
                if (otherMenu !== menu) {
                    activateMenu(otherMenu);
                }
            });
        }
    });
}

function attachSubpageToggleEventHandler(element: Element, menuIndex: number) {
    element.addEventListener('click', () => {
        const menu = menus[menuIndex];
        toggleSubpageParent(menu);
    });
}

function openMenu(menu: MenuProps) {
    menu.container.classList.add(CLASS_MENU_OPEN);
    menu.onBlurEventHandler = event => onMenuBlur(event, menu, true);
    menu.container.addEventListener('click', menu.onBlurEventHandler);
    menu.isOpen = !menu.isOpen;
    menu.toggle.setAttribute('aria-expanded', menu.isOpen ? 'true' : 'false');
    activateMenu(menu);
}

function activateMenu(menu: MenuProps) {
    menu.container.classList.remove(CLASS_MENU_INACTIVE);
}

function deactivateMenu(menu: MenuProps) {
    menu.container.classList.add(CLASS_MENU_INACTIVE);
    closeMenu(menu);
}

function closeMenu(menu: MenuProps) {
    menu.isOpen = false;
    menu.container.classList.remove(CLASS_MENU_OPEN);
    menu.toggle.setAttribute('aria-expanded', 'false');
    menu.container.removeEventListener('click', menu.onBlurEventHandler);
}

function toggleSubpageParent(menu: MenuProps) {
    if (menu.isSubmenuExpanded) {
        menu.list.classList.remove(CLASS_MENU_EXPANDED);
    } else {
        menu.list.classList.add(CLASS_MENU_EXPANDED);
    }

    menu.isSubmenuExpanded = !menu.isSubmenuExpanded;
}

function onMenuBlur(event: Event, menu: MenuProps, firstRun: boolean = false) {
    var isClickInside = firstRun
        ? menu.container.contains(event.target as Node)
        : menu.list.contains(event.target as Node);

    if (!isClickInside && menu.isOpen && !firstRun) {
        closeMenu(menu);
    }

    /** For some reason the handler here is called right after the first click,
     * where it isn't even associated to an event listener. Possibly because of bubble up.
     * So we make sure here, the menu doesn't immediatelly close after opening
     */
    if (firstRun) {
        menu.container.removeEventListener('click', menu.onBlurEventHandler);

        menu.onBlurEventHandler = event => onMenuBlur(event, menu, false);
        menu.container.addEventListener('click', menu.onBlurEventHandler);
    }
}

interface MenuProps {
    container: Element;
    toggle: Element;
    subpageToggles?: NodeListOf<Element>;
    list: Element;
    subpages: {
        activeIndex: number;
    };
    isOpen?: boolean;
    isSubmenuExpanded?: boolean;
    onBlurEventHandler?: EventListenerOrEventListenerObject;
}
